import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 1600px;
    margin: auto;
    padding: 0 20px;
    margin-bottom: 5rem;

    @media (max-width: 1600px) {
        width: 100%;
        padding: 0 20px;
    }
`

export const ContainerWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: left;
    width: 100%;
`

export const NoEventsMessage = styled.p`
    font-size: 18px;
    color: #5a5a5d;
    text-align: center;
    margin-top: 20px;
`
